import React, {Component} from 'react';
import PropTypes from "prop-types";
import {Translate} from "app/services/translate";

export class QuestionerItem extends Component {
    static get propTypes() {
        return {
            question: PropTypes.object,
            isActive: PropTypes.bool,
            hide: PropTypes.bool,
            onClickAnswerBtn: PropTypes.func,
        }
    }

    constructor(props) {
        super(props);
        this.handleAnswerButtonClick = this.handleAnswerButtonClick.bind(this);
    }

    handleAnswerButtonClick() {
        const {onClickAnswerBtn, question} = this.props;

        onClickAnswerBtn(question);
    }

    render() {
        const {question, isActive, hide} = this.props;
        const active = isActive ? 'active' : '';
        const hidden = hide ? 'hide' : '';

        return (
            <div className={`col-12 col-md-4 question ${active} ${hidden}`}>
                <div className="client-image"/>
                <div className="title">{question.title}</div>
                <div className="answer" dangerouslySetInnerHTML={{ __html: question.answer }}/>
                <button type='button' className="answer-btn" onClick={this.handleAnswerButtonClick}>
                    <span className="btn-txt">{Translate('commons_questioner_show_answer')}</span>
                    <span className="employee-image"/>
                </button>
            </div>
        )
    }
}